import ResourceService from './resource.service'

class ModelService extends ResourceService {
  static get resource() {
    return 'made'
  }
   static create(data) {
    return this.post(data);
  }
  static addYear(data) {
  return this.patch("year", data);
}
}

export default ModelService
